import { Trans } from '@lingui/react';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import DownloadIcon from '@mui/icons-material/Download';

export const DownloadFile = ({ url, fileName, onClose }: { url: string; fileName: string; onClose: () => void }) => {
  return (
    <Modal open onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <Box padding={3}>
          <Stack gap={3}>
            <Typography>
              <Trans id="Download file" />
            </Typography>
            <Stack direction="row" spacing={2}>
              <DownloadIcon />
              <Typography>{fileName}</Typography>
            </Stack>

            <Button
              component="a"
              href={url}
              download={fileName}
              onClick={() => {
                /* without this timeout the download wont work */
                setTimeout(onClose, 1);
              }}
            >
              <Trans id="Download" />
            </Button>
          </Stack>
        </Box>
      </ModalDialog>
    </Modal>
  );
};
